
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/transportation",
      function () {
        return require("private-next-pages/solutions/transportation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/transportation"])
      });
    }
  